import { render, staticRenderFns } from "./HeroesPick.vue?vue&type=template&id=6fadf93d&"
import script from "./HeroesPick.vue?vue&type=script&lang=js&"
export * from "./HeroesPick.vue?vue&type=script&lang=js&"
import style0 from "./HeroesPick.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports